/* src/app/pages/paciente/diferencias-paciente/diferencias-paciente.component.scss */
/*# sourceMappingURL=diferencias-paciente.component.css.map */
